<template>
  <v-container fluid class="d-flex flex-column fill-height">
    <v-card
      tile
      flat
      class="d-flex flex-column"
      width="99vw"
      max-width="1200"
      height="calc(89vh - 20px)"
    >
      <v-row justify="center" align="center" class="mb-3 ma-0 pa-0">
        <v-col
          :class="$vuetify.breakpoint.lg ? 'pt-10' : ''"
          cols="5"
          sm="5"
          md="5"
          lg="6"
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          <v-card flat class="d-flex flex-column justify-center align-center">
            <v-img
              width="550"
              max-width="550px"
              :src="photo"
              alt="Onboard concluded photo"
              class="mb-0"
            ></v-img>
          </v-card>
        </v-col>
        <v-col
          cols="7"
          sm="12"
          md="7"
          lg="6"
          :class="$vuetify.breakpoint.lg ? 'pt-10' : ''"
        >
          <v-card
            flat
            class="d-flex flex-column justify-center align-center mr-5"
          >
            <v-card-title
              class="primary--text text-h6 text-sm-h5 font-weight-bold text-center break-word text-wrap normal-line-height"
              style="max-width: 500px"
            >
              {{ $t("offboardingUser.finishOfboardingTitle") }}
            </v-card-title>

            <v-list class="px-0">
              <v-list-item v-for="(item, index) in getStartedList" :key="index">
                <v-list-item-action class="mr-4">
                  <v-icon
                    v-text="'ph-fill ph-check-circle'"
                    size="26"
                    color="success"
                  />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-wrap break-word normal-line-height text-body-1 secondary--text"
                  >
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <FeedbackRating
              class="scale"
              action="offboarding_user"
              :width="`${breakpoint}`"
              txtAreaHeight="90"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-divider style="width: 90vw"></v-divider>
    <v-footer
      rounded
      style="height: 70px"
      color="background"
      class="border-bottom rounded-xl mt-3"
      width="90vw"
    >
      <v-spacer />
      <div>
        <v-btn
          height="52"
          color="accent"
          class="mx-auto text-none text-body-1 font-weight-bold px-8 mr-0"
          @click="$emit('goHome')"
          :loading="loading"
        >
          <v-icon right v-text="'ph-house'" class="mr-4" size="22" />
          {{ $t("common.homePage") }}
        </v-btn>
      </div>
    </v-footer>
  </v-container>
</template>
<script>
import FeedbackRating from "@/components/forms/FeedbackRating.vue";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "ConcludedOffBoarding",
  components: { FeedbackRating },

  data() {
    return {
      photo: require("@/assets/images/concluded-onboarding.svg"),
      loading: false,
      user: {},
    };
  },

  computed: {
    ...mapGetters(["hasInitiatedMigration"]),

    getStartedList() {
      return [
        {
          title: this.$t("offboardingUser.removeLicenseAfterMigration", {
            email: this.user.email,
          }),
          show: this.hasInitiatedMigration,
        },
        {
          title: this.$t("offboardingUser.notifyViaEmail"),
          show: false, // TODO: condicionar para quando enviarmos o email
        },
        {
          title: this.$t("offboardingUser.removeUserFromSuite"),
          show: false, // TODO: condicionar isso para caso o usuário esteja ou não suspenso
        },
      ].filter((item) => item.show);
    },

    breakpoint() {
      if (this.$vuetify.breakpoint.mdAndDown) return 400;
      else return 600;
    },
  },
  methods: {
    ...mapMutations(["setOffboardingStep", "setUserOffboardSelected"]),
    setOffboardingUser() {
      const user = JSON.parse(localStorage.getItem("offboardUser"));
      if (!this.userOffboardSelected && user) {
        this.setUserOffboardSelected(user);
      }
      this.user = user || this.userOffboardSelected;
    },
  },
  beforeMount() {
    this.setOffboardingUser();
  },
};
</script>
<style scoped>
.link-style {
  text-decoration: underline;
  cursor: pointer;
}
</style>
